import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { createQuizWithFile, fetchCategories } from "../services/api";

const CreateQuiz = () => {
  const [quizName, setQuizName] = useState("");
  const [quizDescription, setQuizDescription] = useState("");
  const [quizImgUrl, setQuizImgUrl] = useState("");
  const [file, setFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: "en_US",
    label: "English",
  });


const userProject = sessionStorage.getItem("project"); 
  const userRole = sessionStorage.getItem("userRole");

   


  const projectMap = {
    jagranquiz: "Jagran",
    joshquiz: "Josh",
  };

  const getInitialProject = () => {
    // If NOT superadmin, force the drop-down to default to their assigned project string
    if (userRole !== "super_admin" && userProject) {
      return { value: userProject, label: projectMap[userProject] || userProject };
    }
    // Default fallback for Super Admin dashboard view
    return { value: "jagranquiz", label: "Jagran" };
  };


  const [selectedProject, setSelectedProject] = useState(getInitialProject);

  // --- NEW DATE/TIME STATES ---
  const [quizStartTime, setQuizStartTime] = useState("");
  const [quizEndTime, setQuizEndTime] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [quizDuration, setQuizDuration] = useState("");
  const navigate = useNavigate();

  // useEffect(() => {

  //   const projectFilter = userRole !== "super_admin" ? userProject : null;
  //   const loadCategories = async () => {
  //     try {
  //       const fetchedCategories = await fetchCategories(projectFilter);
  //       setCategories(fetchedCategories || []);
  //     } catch (error) {
  //       console.error("Failed to load categories:", error.message || error);
  //       alert("Failed to load categories. Please try again later.");
  //     }
  //   };

  //   loadCategories();
  // }, []);
// --- UPDATED: LOAD CATEGORIES BASED DYNAMICALLY ON DROPDOWN CHOICE FOR SUPER ADMIN ---
useEffect(() => {
  const loadCategories = async () => {
    try {
      // 1. Reset category choice immediately when the project changes
      setSelectedCategory(null); 

      // 2. Check what value is currently selected in the Project dropdown
      let projectFilter = selectedProject ? selectedProject.value : null;

      // 3. If a regular Admin/User is logged in, force their restricted project token instead
      if (userRole !== "super_admin") {
        projectFilter = userProject;
      }

      // 4. Fire the API call with the determined project identifier
      if (projectFilter) {
        const fetchedCategories = await fetchCategories(projectFilter);
        setCategories(fetchedCategories || []);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.error("Failed to load categories:", error.message || error);
      setCategories([]);
    }
  };

  loadCategories();
}, [selectedProject, userRole, userProject]); // Triggers every time the dropdown selection changes


  const categoryOptions = categories.map((category) => ({
    value: category.cat_id,
    label: category.parent
      ? `${category.cat_name}`
      : category.cat_name,
  }));

  const languageOptions = [
    { value: "en_US", label: "English" },
    { value: "hi_IN", label: "Hindi" },
  ];

 const baseProjectOptions = [
    { value: "jagranquiz", label: "Jagran" },
    { value: "joshquiz", label: "Josh" },
  ];

  // ONLY superadmin gets both options. admin and user are filtered down to their assigned key.
  const projectOptions = userRole === "super_admin" 
    ? baseProjectOptions 
    : baseProjectOptions.filter(option => option.value === userProject);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!quizName || !quizDescription || !file || !selectedCategory) {
      alert("Please fill out all required fields.");
      return;
    }

    // Validate all Jagran-specific fields at once
    if (selectedProject.value === "jagranquiz" && (!quizStartTime || !quizEndTime || !quizDuration)) {
      alert("Please fill out the Start Date, End Date, and Playing Time for Jagran project.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("quiz_name", quizName);
    formData.append("quiz_description", quizDescription);
    formData.append("quiz_img_url", quizImgUrl);
    formData.append("category[cat_id]", selectedCategory.value);
    formData.append("category[cat_name]", selectedCategory.label);
    formData.append("language", selectedLanguage.value);
    formData.append("project", selectedProject.value);

    if (selectedProject.value === "jagranquiz") {
      // const startEpoch = new Date(quizStartTime).getTime();
      // const endEpoch = new Date(quizEndTime).getTime();

      // Setting the end time string to the very end of the selected day
const startEpoch = new Date(quizStartTime).getTime(); // Starts at 00:00:00
const endEpoch = new Date(`${quizEndTime}T23:59:59`).getTime(); // Ends at 23:59:59
      //quiz_start_date
      console.log(quizStartTime);
      formData.append("quiz_start_time", startEpoch);
      
      formData.append("quiz_end_time", endEpoch);
      formData.append("quiz_start_date", quizStartTime);
      formData.append("quiz_duration", Number(quizDuration));
    }

    setIsUploading(true);
    setProgress(0);

    try {
      await createQuizWithFile(formData, (event) => {
        const percent = Math.round((event.loaded / event.total) * 100);
        setProgress(percent);
      });

      setIsUploading(false);
      setShowSuccessPopup(true);

      // Clear all fields after success
      setQuizName("");
      setQuizDescription("");
      setQuizImgUrl("");
      setFile(null);
      setSelectedCategory(null);
      setQuizStartTime(""); // Reset
      setQuizEndTime("");   // Reset
      setQuizDuration("");
      setSelectedProject(getInitialProject());
      //setSelectedProject({ value: "jagranquiz", label: "Jagran" });
      setSelectedLanguage({ value: "en_US", label: "English" }); // Reset to default
      setTimeout(() => setShowSuccessPopup(false), 3000); // Hide popup after 3 seconds
    } catch (error) {
      console.error("Error creating quiz:", error.response || error.message);
      alert("Failed to create quiz.");
      setIsUploading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Create New Quiz</h1>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Quiz Name:</label>
          <input
            type="text"
            value={quizName}
            onChange={(e) => setQuizName(e.target.value)}
            style={styles.input}
            required
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Quiz Description:</label>
          <textarea
            value={quizDescription}
            onChange={(e) => setQuizDescription(e.target.value)}
            style={styles.textarea}
            required
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Quiz Image URL (Optional):</label>
          <input
            type="text"
            value={quizImgUrl}
            onChange={(e) => setQuizImgUrl(e.target.value)}
            style={styles.input}
            placeholder="Enter image URL"
          />
        </div>



<div style={styles.formGroup}>
          <label style={styles.label}>Project:</label>
          <Select
            options={projectOptions}
            value={selectedProject}
            onChange={(option) => setSelectedProject(option)}
            isSearchable={userRole === "super_admin"} // Disabled filtering search for standard Admins/Users
            isDisabled={userRole !== "super_admin"}  // Freezes drop-down option cleanly if they don't have override privileges
            placeholder="Select a project"
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Category:</label>
          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={(option) => setSelectedCategory(option)}
            isSearchable
            placeholder="Search or select a category"
          />
        </div>



{/* --- CONDITIONAL FIELDS FOR JAGRAN PROJECT --- */}
        {/* {selectedProject && selectedProject.value === "jagranquiz" && (
          <>
            <div style={styles.formGroup}>
              <label style={styles.label}>Quiz Start Date & Time:</label>
              <input
                type="datetime-local"
                value={quizStartTime}
                onChange={(e) => setQuizStartTime(e.target.value)}
                style={styles.input}
                required
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Quiz End Date & Time:</label>
              <input
                type="datetime-local"
                value={quizEndTime}
                onChange={(e) => setQuizEndTime(e.target.value)}
                style={styles.input}
                required
              />
            </div>
          </>
        )} */}


        {/* --- CONDITIONAL FIELDS FOR JAGRAN PROJECT --- */}
        {/* --- CONDITIONAL FIELDS FOR JAGRAN PROJECT --- */}
        {selectedProject && selectedProject.value === "jagranquiz" && (
          <>
            <div style={styles.formGroup}>
              <label style={styles.label}>Quiz Start Date:</label>
              <input
                type="date"
                value={quizStartTime}
                onChange={(e) => setQuizStartTime(e.target.value)}
                style={styles.input}
                required
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Quiz End Date:</label>
              <input
                type="date"
                value={quizEndTime}
                onChange={(e) => setQuizEndTime(e.target.value)}
                style={styles.input}
                required
              />
            </div>
            {/* Added here so it only shows up for Jagran */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Quiz Playing Time (in seconds):</label>
              <input
                type="number"
                min="0"
                value={quizDuration}
                onChange={(e) => setQuizDuration(e.target.value)}
                style={styles.input}
                placeholder="e.g. 60, 120, 150"
                required
              />
            </div>
          </>
        )}

        <div style={styles.formGroup}>
          <label style={styles.label}>Language:</label>
          <Select
            options={languageOptions}
            value={selectedLanguage}
            onChange={(option) => setSelectedLanguage(option)}
            isSearchable
            placeholder="Select a language"
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Upload Excel File:</label>
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={(e) => setFile(e.target.files[0])}
            value={file ? undefined : ""}
            style={styles.fileInput}
            required
          />
        </div>
        {isUploading && (
          <div style={styles.progressContainer}>
            <div style={{ ...styles.progressBar, width: `${progress}%` }} />
            <span style={styles.progressText}>{progress}%</span>
          </div>
        )}
        <button type="submit" style={styles.submitButton}>
          Create Quiz
        </button>
      </form>
      {showSuccessPopup && (
        <div style={styles.successPopup}>
          <p>Quiz created successfully!</p>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  title: {
    marginBottom: "30px",
    fontSize: "28px",
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "bold",
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  textarea: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    minHeight: "80px",
  },
  fileInput: {
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  progressContainer: {
    position: "relative",
    width: "100%",
    height: "20px",
    backgroundColor: "#f0f0f0",
    borderRadius: "10px",
    overflow: "hidden",
    marginTop: "10px",
    marginBottom: "20px",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#4caf50",
    transition: "width 0.3s ease",
  },
  progressText: {
    position: "absolute",
    width: "100%",
    textAlign: "center",
    top: "0",
    fontSize: "12px",
    color: "#333",
  },
  submitButton: {
    padding: "12px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
  },
  successPopup: {
    position: "fixed",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#dff0d8",
    color: "#3c763d",
    padding: "20px",
    borderRadius: "5px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
  },
};

export default CreateQuiz;
